import { createContext, useContext } from 'react';
import { ExternalViewerAPI } from './types';

export const ExternalViewerAPIContext = createContext<ExternalViewerAPI | undefined>(
  undefined,
);

export const useExternalViewerAPI = () => {
  const ctx = useContext(ExternalViewerAPIContext);
  if (!ctx)
    throw new Error('useExternalViewerAPI must be used within ExternalViewerAPIProvider');
  return ctx;
};
